import 'bootstrap';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {

    window.addEventListener('scroll', () => {
        document.body.classList.toggle('scroll-offset', window.scrollY > 0);
    });

    document.querySelector('.js-hamburger')?.addEventListener('click', function () {
        this.classList.toggle('is-active');
        const menu = document.querySelector('.main-menu');
        menu.classList.toggle('is-active');
        document.body.classList.toggle('nav-is-active', menu.classList.contains('is-active'));
    });

    document.querySelector('.js-search')?.addEventListener('click', e => {
        e.preventDefault();
        document.querySelector('.search-bar')?.classList.toggle('is-active');
    });

    const swiperEl = document.querySelector('.masthead-swiper .swiper');
    if (swiperEl) {
        new Swiper(swiperEl, {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            speed: 600,
            autoHeight: true,
            autoplay: {
                delay: 7000,
                pauseOnMouseEnter: true,
                disableOnInteraction: true,
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            loop: true,
        });
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', e => {
            const target = document.querySelector(anchor.getAttribute('href'));
            if (!target) return;
            e.preventDefault();
            window.scrollTo({ top: target.offsetTop - 120, behavior: 'smooth' });
        });
    });

});